import { axiosInstance } from '~/src/config/config_axios'
import { makeQueryUrl } from '~/src/libs'
import { convertWishListData } from '~/src/repositories/WishList/helper/convertWishListData'
import { IWishListParams, IWishListResponse } from '~/src/repositories/WishList/models/WishList'

export class WishListRepository {
  async getWishLists(params?: IWishListParams): Promise<IWishListResponse> {
    const { data } = await axiosInstance.get(makeQueryUrl('/wish-lists', params))
    return convertWishListData(data)
  }

  async exportExcel(params?: IWishListParams): Promise<any> {
    return await axiosInstance.get(makeQueryUrl('/wish-lists/excel', params), {
      responseType: 'arraybuffer',
    })
  }
}
